export enum MapFilter {
    Friendly,
    PullPrice
}
